/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Founder_Chris_TitleInputs */

const en_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

const de_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgruender & Operations`)
};

const fr_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

const es_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

const it_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

const nl_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

const pl_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

const fi_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

const da_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

const sv_about_founder_chris_title = /** @type {(inputs: About_Founder_Chris_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

/**
* | output |
* | --- |
* | "Co-Founder & Operations" |
*
* @param {About_Founder_Chris_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_founder_chris_title = /** @type {((inputs?: About_Founder_Chris_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Founder_Chris_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_founder_chris_title(inputs)
	if (locale === "fr") return fr_about_founder_chris_title(inputs)
	if (locale === "es") return es_about_founder_chris_title(inputs)
	if (locale === "it") return it_about_founder_chris_title(inputs)
	if (locale === "nl") return nl_about_founder_chris_title(inputs)
	if (locale === "pl") return pl_about_founder_chris_title(inputs)
	if (locale === "fi") return fi_about_founder_chris_title(inputs)
	if (locale === "da") return da_about_founder_chris_title(inputs)
	if (locale === "sv") return sv_about_founder_chris_title(inputs)
	return en_about_founder_chris_title(inputs)
});